<template>
  <path
    d="M7.95 3.45C7.95 3.20147 7.74853 3 7.5 3C7.25147 3 7.05 3.20147 7.05 3.45V7.05H3.45C3.20147 7.05 3 7.25147 3 7.5C3 7.74853 3.20147 7.95 3.45 7.95H7.05V11.55C7.05 11.7985 7.25147 12 7.5 12C7.74853 12 7.95 11.7985 7.95 11.55V7.95H11.55C11.7985 7.95 12 7.74853 12 7.5C12 7.25147 11.7985 7.05 11.55 7.05H7.95V3.45Z"
    fill="currentColor" />
</template>
